import React from "react";
import { SelectValue } from "antd/es/select";
import { SearchOutlined } from "@ant-design/icons";
import { Col, Divider, Form, Radio } from "antd";
import styles from "./index.module.scss";
import { EffectiveDate } from "../../../../../types/model/saveOffer";
import DebounceSearchInput from "../../../../../components/DebounceSearchInput";
import { Option } from "./index";

interface SaveOfferSwitchPlanProps {
  planList: Option[];
  setPlanList: React.Dispatch<React.SetStateAction<Option[]>>;
  handleVariantsSearch: (search: string) => Promise<Option[]>;
  handleSwitchPlanInputChange: (value: SelectValue) => void;
}

export function SaveOfferSwitchPlan({
  planList,
  setPlanList,
  handleVariantsSearch,
  handleSwitchPlanInputChange,
}: SaveOfferSwitchPlanProps) {
  return (
    <>
      <Divider className={styles.divider} />
      <Col span={24}>
        <Form.Item
          label="Effective date"
          name="effectiveDate"
          initialValue={EffectiveDate.IMMEDIATELY}
          rules={[{ required: true }]}
        >
          <Radio.Group>
            {Object.values(EffectiveDate).map((type) => (
              <Radio key={type} value={type}>
                {type}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item label="Switch to plan" name="switchToPlanPid" rules={[{ required: true }]}>
          <DebounceSearchInput
            showSearch
            onChange={handleSwitchPlanInputChange}
            fetchOptions={handleVariantsSearch}
            existedOptions={planList}
            onClear={() => {
              setPlanList([]);
            }}
            allowClear
            placeholder="Search PID or plan name"
            suffixIcon={<SearchOutlined className={styles.searchIcon} />}
          />
        </Form.Item>
      </Col>
    </>
  );
}
